import React from 'react'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { PageTitle } from '../../layout/core'
import AllInstagram from './AllInstagram'
import CreateNewInstagramBot from './CreateNewInstagramBot'
import InstagramBotBuilder from './instagramBotBuilder'

const InstagramBots = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/all-bots'
          element={
            <>
              <PageTitle breadcrumbs={[]}>All Instagram Bots</PageTitle>
              <AllInstagram />
            </>
          }
        />

        <Route
          path='/create-new-instagram-bot'
          element={
            <>
              <PageTitle breadcrumbs={[]}>Create New Instagram Bot</PageTitle>
              <CreateNewInstagramBot />
            </>
          }
        />

        <Route
          path='/bot-builder/:uuid'
          element={
            <>
              <PageTitle breadcrumbs={[]}>Instagram Bot Builder</PageTitle>
              <InstagramBotBuilder />
            </>
          }
        />

        <Route index element={<Navigate to='/instagram-bots/all-bots' />} />
      </Route>
    </Routes>
  )
}

export default InstagramBots
